import payment from "@/plugins/api/factories/PaymentHistory";

export const state = {
  paymentHistory: [],
  isLoading: false, // ✅ Добавили состояние загрузки
};

export const actions = {
  async getAllPaymentHistory({ commit, rootState }, { accountId } = {}) {
    // Используем переданный accountId, если он есть, иначе берем из текущего аккаунта
    const ls = accountId || rootState.Auth.account.ls;
    const cacheKey = `paymentHistory_${ls}`;

    // 1. Попробовать загрузить данные из кеша
    const cachedHistory = localStorage.getItem(cacheKey);
    if (cachedHistory) {
      try {
        commit("SET_PAYMENT_HISTORY", JSON.parse(cachedHistory));
      } catch (e) {
        console.error("Ошибка парсинга кеша истории платежей:", e);
      }
    }

    // 2. Если кеша нет, показать скелетон
    if (!cachedHistory) {
      commit("SET_IS_LOADING", true);
    }

    const credentials = rootState.Auth.userCredentials;
    const sessionId = rootState.Auth.sessionId;

    if (!sessionId && !credentials) {
      commit("SET_PAYMENT_HISTORY", []);
      commit("SET_IS_LOADING", false);
      return;
    }

    // 3. В любом случае запросить свежие данные в фоне
    await payment.getAllPayments(
      ls,
      credentials,
      (response) => {
        if (response && Array.isArray(response.items)) {
          commit("SET_PAYMENT_HISTORY", response.items);
          // 4. Сохранить свежие данные в кеш
          localStorage.setItem(cacheKey, JSON.stringify(response.items));
        } else {
          commit("SET_PAYMENT_HISTORY", []);
        }
        // 5. Скрыть скелетон после получения ответа
        commit("SET_IS_LOADING", false);
      },
      sessionId
    );
  },
};

export const mutations = {
  SET_PAYMENT_HISTORY(state, paymentHistory) {
    state.paymentHistory = paymentHistory;
  },
  // ✅ Новая мутация
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
};
